export default __webpack_public_path__ + "static/t4-84476853196de77dfeb951b24989c2ef.webp";